"use strict";

;
(function (Example, $) {
  // Function Library

  // DOM user events
  var eventHandlers = function eventHandlers() {};
  Example.init = function () {
    // we always use eventHandlers() namespace,
    // whenever there are DOM events
    eventHandlers();
    console.log('example logged');
  };
})(window.Example = window.Example || {}, jQuery, undefined);